{
  "clinicalNotes": "Nota Klinikal",
  "noteType": "Jenis Nota",
  "author": "Penulis",
  "dateTime": "Tarikh/Masa",
  "content": "Kandungan",
  "addNote": "Tambah Nota",
  "editNote": "Sunting Nota",
  "signNote": "Tandatangan Nota",
  "signed": "Ditandatangani",
  "unsigned": "Belum Ditandatangani",
  "types": {
    "progressNote": "Nota Kemajuan",
    "admissionNote": "Nota Kemasukan",
    "dischargeNote": "Nota Discaj",
    "consultNote": "Nota Konsultasi",
    "procedureNote": "Nota Prosedur"
  },
  "editor": {
    "newNote": "Nota Baru",
    "titlePlaceholder": "Tajuk nota…",
    "create": "Cipta",
    "cancel": "Batal",
    "cosignFilterLabel": "Tunjukkan Nota yang Perlu Tandatangan Bersama Saya",
    "emptyNoCosign": "Tiada nota memerlukan tandatangan bersama anda",
    "emptyNoNotes": "Belum ada nota",
    "emptySelection": "Pilih nota atau cipta yang baru",
    "emptySelectionHint": "Pilih daripada senarai di sebelah kiri atau klik \"+ Nota Baru\" untuk mula.",
    "unknownAuthor": "Tidak diketahui",
    "needsCosignBadge": "Perlu Tandatangan Bersama",
    "amendmentBanner": "Pindaan nota #{{parentId}} — Sebab: {{reason}}",
    "signedBanner": "Ditandatangani oleh {{name}} pada {{when}} — Nota ini baca sahaja.",
    "signedByFallback": "doktor",
    "saving": "Menyimpan…",
    "autoSaved": "Disimpan secara automatik",
    "actions": {
      "saveDraft": "Simpan Draf",
      "signNote": "Tandatangan Nota",
      "amend": "Pinda",
      "cosign": "Tandatangan Bersama",
      "printLabel": "Cetak Nota"
    },
    "copyForward": "Salin nota terakhir",
    "copyForwardHint": "Menyalin nota bertandatangan dari {{date}} — semak dan kemas kini setiap baris",
    "copiedForwardBadge": "Disalin"
  },
  "dialog": {
    "sign": {
      "title": "Tandatangan Nota",
      "body": "Pasti mahu menandatangani nota ini? Tindakan ini tidak boleh dibatalkan. Nota akan menjadi baca sahaja selepas ditandatangani.",
      "cancel": "Batal",
      "confirm": "Sahkan Tandatangan"
    },
    "amend": {
      "title": "Pinda Nota",
      "body": "Sila berikan sebab pindaan ini. Nota akan dikemas kini dan ditanda sebagai dipinda.",
      "reasonPlaceholder": "Sebab pindaan…",
      "cancel": "Batal",
      "confirm": "Sahkan Pindaan"
    },
    "cosign": {
      "title": "Tandatangan Bersama Nota",
      "body": "Pasti mahu menandatangani nota ini bersama? Ini bermakna anda telah menyemak dan bersetuju dengan kandungan nota.",
      "cancel": "Batal",
      "confirm": "Sahkan Tandatangan Bersama"
    }
  },
  "toast": {
    "created": "Nota dicipta",
    "createFailed": "Gagal mencipta nota",
    "titleRequired": "Sila masukkan tajuk nota",
    "draftSaved": "Draf disimpan",
    "signed": "Nota berjaya ditandatangani",
    "signFailed": "Gagal menandatangani nota",
    "amended": "Nota berjaya dipinda",
    "amendFailed": "Gagal meminda nota",
    "amendReasonRequired": "Sila berikan sebab pindaan",
    "cosigned": "Nota berjaya ditandatangani bersama",
    "cosignFailed": "Gagal menandatangani nota bersama"
  },
  "status": {
    "draft": "Draf",
    "unsigned": "Belum Ditandatangani",
    "signed": "Ditandatangani",
    "amended": "Dipinda",
    "cosigned": "Ditandatangani Bersama",
    "cosignNeeded": "Perlu Tandatangan Bersama",
    "pendingSignature": "Menunggu Tandatangan",
    "addendum": "Tambahan",
    "cosignPending": "Menunggu Tandatangan Bersama"
  },
  "worklist": {
    "title": "Senarai Tugas Nota Belum Ditandatangani",
    "backToDashboard": "Papan Pemuka",
    "filtersHeading": "Penapis",
    "filterAllNoteTypes": "Semua Jenis Nota",
    "filterAllStatuses": "Semua Status",
    "filterAuthorPlaceholder": "Tapis ikut penulis…",
    "dateFromAria": "Tarikh mula",
    "dateToAria": "Tarikh akhir",
    "columns": {
      "patient": "Pesakit",
      "mrn": "MRN",
      "noteType": "Jenis Nota",
      "noteTitle": "Tajuk",
      "author": "Penulis",
      "created": "Dicipta",
      "status": "Status",
      "actions": "Tindakan"
    },
    "actions": {
      "signSelected": "Tandatangan Pilihan ({{count}})",
      "signing": "Menandatangan…",
      "open": "Buka",
      "refresh": "Segar semula"
    },
    "loading": "Memuatkan nota…",
    "empty": "Tiada nota belum ditandatangani",
    "loadError": "Gagal memuatkan nota yang belum ditandatangani",
    "retry": "Cuba lagi",
    "toast": {
      "noneSelected": "Tiada nota dipilih",
      "signed_one": "{{count}} nota berjaya ditandatangani",
      "signed_other": "{{count}} nota berjaya ditandatangani",
      "signFailed": "Gagal menandatangani sebahagian nota",
      "partiallySigned_one": "{{count}} nota ditandatangani, {{failed}} gagal",
      "partiallySigned_other": "{{count}} nota ditandatangani, {{failed}} gagal"
    }
  },
  "type": {
    "progress": "Nota Kemajuan",
    "historyPhysical": "H&P",
    "admission": "Nota Kemasukan",
    "discharge": "Ringkasan Discaj",
    "consult": "Konsultasi",
    "procedure": "Nota Prosedur",
    "operative": "Nota Pembedahan",
    "nursing": "Nota Kejururawatan"
  },
  "template": {
    "list": {
      "title": "Templat Nota",
      "backToDashboard": "Papan Pemuka",
      "newButton": "Templat Baru",
      "columns": {
        "name": "Nama",
        "noteType": "Jenis Nota",
        "specialty": "Pengkhususan",
        "sections": "Bahagian",
        "status": "Status",
        "actions": "Tindakan"
      },
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "loading": "Memuatkan templat…",
      "empty": "Tiada templat. Cipta satu untuk bermula.",
      "previewTitle": "Pratonton Templat: {{name}}",
      "emptySection": "(kosong)",
      "tooltips": {
        "preview": "Pratonton",
        "edit": "Sunting",
        "activate": "Aktifkan",
        "deactivate": "Nyahaktifkan"
      },
      "toast": {
        "statusUpdated": "Status templat dikemas kini"
      }
    },
    "form": {
      "editTitle": "Sunting Templat",
      "createTitle": "Cipta Templat",
      "fields": {
        "name": "Nama Templat",
        "noteType": "Jenis Nota",
        "specialty": "Pengkhususan",
        "sections": "Bahagian"
      },
      "required": "*",
      "namePlaceholder": "cth., Nota Kemajuan Standard",
      "selectNoteType": "Pilih jenis…",
      "selectSpecialty": "Pilih pengkhususan…",
      "addSection": "Tambah Bahagian",
      "sectionNamePlaceholder": "Nama bahagian (cth., Aduan Utama)",
      "sectionDefaultPlaceholder": "Kandungan lalai untuk bahagian ini…",
      "cancel": "Batal",
      "create": "Cipta Templat",
      "update": "Kemas Kini Templat",
      "toast": {
        "created": "Templat dicipta",
        "updated": "Templat dikemas kini",
        "saveFailed": "Gagal menyimpan templat",
        "nameAndTypeRequired": "Nama dan jenis nota diperlukan",
        "atLeastOneSection": "Sekurang-kurangnya satu bahagian diperlukan"
      }
    },
    "specialty": {
      "general": "Am",
      "internalMedicine": "Perubatan Dalaman",
      "surgery": "Pembedahan",
      "pediatrics": "Pediatrik",
      "cardiology": "Kardiologi",
      "neurology": "Neurologi",
      "orthopedics": "Ortopedik",
      "emergencyMedicine": "Perubatan Kecemasan"
    },
    "scope": {
      "personal": "Peribadi",
      "group": "Kumpulan",
      "global": "Seluruh Hospital"
    },
    "state": {
      "draft": "Draf",
      "published": "Diterbitkan"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "Tebal",
      "italic": "Condong",
      "list": "Senarai",
      "templates": "Templat / Frasa Pintar",
      "saved": "Disimpan {{time}}",
      "notSaved": "Belum disimpan",
      "charactersLabel": "aksara",
      "save": "Simpan {{noteType}}",
      "placeholder": "Mula menaip {{noteType}} anda… Guna \".\" untuk mencetuskan frasa pintar.",
      "smartPhrases": {
        "patientName": "Nama Pesakit",
        "mrn": "Nombor Rekod Perubatan",
        "dateOfBirth": "Tarikh Lahir",
        "allergies": "Alahan",
        "vitals": "Tanda Vital",
        "medications": "Ubat",
        "problemList": "Senarai Masalah"
      }
    }
  }
}
